<template>
    <v-popover style="display: inline-block; padding-left: 5px">
        <div class="help-icon">
            <icon :icon="['fal', 'question-circle']"/>
        </div>
        <template slot="popover">
            <template v-if="helpContent != null">
                <simple-button @press="switchMode">
                    <icon :icon="['fal', mode == 'READ' ? 'edit' : 'glasses' ]"/>
                </simple-button>
            </template>
            <template v-if="helpContent != null && helpContent.length > 0">
                <vue-markdown v-if="mode == 'READ'" :source="helpContent[0].content" style="max-width: 40vw;"/>
                <template v-if="mode == 'EDIT'">
                    <textarea cols="110" rows="20" v-model="helpContent[0].content"/>
                    <simple-button @press="saveHelpContent">
                        <icon :icon="['fal', 'save']"/>
                    </simple-button>
                </template>
            </template>
        </template>
    </v-popover>
</template>

<script>
    import SimpleButton from "../button/SimpleButton";
    export default {
        name: "ContextHelp",
        components: {SimpleButton},
        props: {
            helpItemCode: String
        },
        data: function() {
            return {
                helpContent: null,
                mode: 'READ'
            }
        },
        methods: {
            saveHelpContent() {
                this.$store.dispatch("gui/saveHelpItem", JSON.stringify(this.helpContent[0]))
                    .then(() => this.switchMode());
            },
            switchMode() {
                if(this.mode == 'READ') {
                    if(this.helpContent.length == 0) {
                        this.helpContent = [{
                            content: "",
                            language: "EN",
                            code: this.helpItemCode
                        }];
                    }
                    this.mode = 'EDIT';
                }
                else
                    this.mode = 'READ';
            },
        },
        watch: {
            helpItemCode: {
                immediate: true,
                handler(newValue, oldValue) {
                    if(newValue != undefined) {
                        this.$store.dispatch("gui/loadHelpItem", newValue)
                            .then(res => this.helpContent = res);
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>